<template>
  <div>
    <div class="field has-text-right" style="padding: 10px; background-color: #f4f4f4; border-radius: 5px;">
      <b-switch v-model="filters.showFinished">終了アンケートを表示</b-switch>
    </div>
    <b-table
      :data="filteredData"
      :default-sort="['id']"
      :default-sort-direction="'desc'"
      :rowClass="rowClass"
    >
      <template slot-scope="props">
        <b-table-column field="id" label="ID" width="40" sortable numeric>
          {{ props.row.id }}
        </b-table-column>

        <b-table-column field="title" label="タイトル" sortable>
          <div v-if="props.row.immutable">{{ props.row.title }}</div>
          <a v-else @click="activeSurvey = props.row; modals.editSurveyTitle = true">
            <b-tag type="is-light">{{ props.row.title }}</b-tag>
          </a>
        </b-table-column>

        <b-table-column field="questions.length" label="設問" sortable numeric>
          {{ props.row.questions.length }}件
        </b-table-column>

        <b-table-column field="answers_count" label="回答者" sortable numeric>
          {{ props.row.answers_count }}人
        </b-table-column>

        <b-table-column field="environment.value" label="公開先" sortable>
          <div v-if="props.row.immutable">{{ props.row.environment.value }}</div>
          <a v-else @click="activeSurvey = props.row; modals.editSurveyEnvironment = true">
            <b-tag type="is-light">{{ props.row.environment.value }}</b-tag>
          </a>
        </b-table-column>

        <b-table-column field="publish_starts_at" label="公開終了日" sortable>
          <div v-if="props.row.immutable">{{ props.row.expires_at }}</div>
          <a v-else @click="activeSurvey = props.row; modals.editSurveyPublishEndsAt = true">
            <b-tag type="is-light">{{ props.row.expires_at }}</b-tag>
          </a>
        </b-table-column>

        <b-table-column field="finished" label="状態">
          <b-taglist>
            <b-tag v-if="props.row.immutable" type="is-danger">編集不可</b-tag>
            <b-tag v-if="props.row.finished" type="is-dark">終了</b-tag>
          </b-taglist>
        </b-table-column>

        <b-table-column field="active" label="公開">
          <b-tooltip
            v-if="props.row.finished"
            label="公開終了日が過ぎています。"
            position="is-left"
          >
            <b-switch disabled />
          </b-tooltip>

          <b-switch v-else v-model="props.row.published" @input="props.row.published ? publishSurvey(props.row) : unpublishSurvey(props.row)"/>
        </b-table-column>

        <b-table-column style="text-align: right;">
          <b-dropdown position="is-bottom-left">
            <div class="tag is-success" slot="trigger" style="cursor: pointer;">
              メニュー
              <b-icon icon="menu-down"></b-icon>
            </div>

            <b-dropdown-item v-if="props.row.immutable" disabled>設問管理</b-dropdown-item>
            <b-dropdown-item v-else @click="$router.push(`/app/surveys/${props.row.id}`)">設問管理</b-dropdown-item>
            <b-dropdown-item @click="activeSurvey = props.row; modals.preview = true">プレビュー</b-dropdown-item>
            <b-dropdown-item separator/>
            <b-dropdown-item @click="makeCopy(props.row)">コピーする</b-dropdown-item>
            <b-dropdown-item v-if="props.row.finished" disabled>終了する</b-dropdown-item>
            <b-dropdown-item v-else @click="setFinished(props.row)">終了する</b-dropdown-item>
            <b-dropdown-item separator/>
            <b-dropdown-item @click="downloadAnswers(props.row)">回答をダウンロードする</b-dropdown-item>
          </b-dropdown>
        </b-table-column>
      </template>
    </b-table>

    <b-modal @close="refresh()" :active.sync="modals.editSurveyTitle">
      <div style="background-color: #fff; padding: 20px; border-radius: 5px;">
        <EditSurveyTitle :survey="activeSurvey" />
      </div>
    </b-modal>

    <b-modal @close="refresh()" :active.sync="modals.editSurveyEnvironment">
      <div style="background-color: #fff; padding: 20px; border-radius: 5px;">
        <EditSurveyEnvironment :survey="activeSurvey" />
      </div>
    </b-modal>

    <b-modal @close="refresh()" :active.sync="modals.editSurveyPublishEndsAt">
      <div style="background-color: #fff; padding: 20px; border-radius: 5px;">
        <EditSurveyPublishEndsAt :survey="activeSurvey" />
      </div>
    </b-modal>

    <b-modal :active.sync="modals.preview">
      <div style="background-color: #fff; padding: 20px; border-radius: 5px; max-height: 90vh; overflow: scroll;">
        <SurveyPreview :survey="activeSurvey"/>
      </div>
    </b-modal>

    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
  </div>
</template>

<script>
import SurveyPreview from './Modals/SurveyPreview'
import EditSurveyTitle from './Modals/EditSurveyTitle'
import EditSurveyEnvironment from './Modals/EditSurveyEnvironment'
import EditSurveyPublishEndsAt from './Modals/EditSurveyPublishEndsAt'
import axios from '@/axios'

export default {
  components: {
    SurveyPreview,
    EditSurveyTitle,
    EditSurveyEnvironment,
    EditSurveyPublishEndsAt,
  },

  data() {
    return {
      isLoading: true,

      modals: {
        editSurveyTitle: false,
        editSurveyEnvironment: false,
        editSurveyPublishEndsAt: false,
        preview: false,
      },

      filters: {
        showFinished: false,
      },

      activeSurvey: null,

      highlightRow: null,

      data: [],
    }
  },

  computed: {
    filteredData() {
      if (this.filters.showFinished) {
        return this.data
      }

      return this.data.filter(a => !a.finished)
    }
  },

  created() {
    this.refresh()
  },

  methods: {
    refresh() {
      this.isLoading = true

      return axios.get('/api/app/surveys').then(({ data }) => {
        this.data = data.data
        this.isLoading = false
      })
    },

    rowClass(survey) {
      if (survey.id === this.highlightRow) {
        return 'highlightRow'
      }

      return 'hightlightRowBase'
    },

    publishSurvey(survey) {
      this.$dialog.confirm({
        title: 'アンケートを公開します',
        message: [
          `公開先「${survey.environment.value}」に他の公開中のアンケートがあれば、そちらが非公開になります。`,
          `同時に、このアンケートの設問の編集ができなくなります。`,
        ].join('<br>'),
        cancelText: 'やめる',
        confirmText: '公開する',
        onCancel: () => {
          survey.published = false;
        },
        onConfirm: () => {
          axios.post('/api/app/surveys/' + survey.id + '/publish').then(() => {
            this.$toast.open({
              message: `「${survey.title}」を「${survey.environment.value}」に公開しました。`,
              type: 'is-success'
            })

            this.refresh()
          })
        },
      })
    },

    unpublishSurvey(survey) {
      this.$dialog.confirm({
        title: 'アンケートを非公開にします',
        message: [
          `公開先「${survey.environment.value}」に公開中のアンケートがなくなります。`,
        ].join('<br>'),
        cancelText: 'やめる',
        confirmText: '非公開にする',
        onCancel: () => {
          survey.published = true;
        },
        onConfirm: () => {
          axios.post('/api/app/surveys/' + survey.id + '/unpublish').then(() => {
            this.$toast.open({
              message: `「${survey.title}」を非公開にしました。`,
              type: 'is-success'
            })

            this.refresh()
          })
        },
      })
    },

    downloadAnswers(survey) {
      let token = localStorage.getItem("X-Token")
      window.location.href = `/api/app/surveys/${token}/${survey.id}.csv`
    },

    makeCopy(survey) {
      this.$dialog.confirm({
        title: 'コピー処理',
        message: [
          `アンケート「${survey.title}」をコピーして新たにアンケートを作成します。`,
          ``,
          `注意：`,
          `・回答はコピーされません。`,
          `・公開終了日が初期値で1ヶ月先になります。アンケート一覧でも修正可能です。`,
          ``,
          `コピーしてもよろしいですか？`,
        ].join('<br>'),
        cancelText: 'やめる',
        confirmText: 'コピーする',
        onCancel: () => {},
        onConfirm: () => {
          axios.post('/api/app/surveys/' + survey.id + '/copy').then(({ data }) => {
            this.$toast.open({
              message: `「${survey.title}」をコピーしました。`,
              type: 'is-success'
            })

            this.refresh().then(() => {
              this.setHighlightRow(data.data.id)
            })
          })
        },
      })
    },

    setFinished(survey) {
      this.$dialog.confirm({
        title: '終了処理',
        message: [
          `アンケート「${survey.title}」を終了します。`,
          ``,
          `注意：`,
          `・未公開の場合、設問の編集ができなくなります。`,
          `・再度公開することができません。`,
          ``,
          `終了してもよろしいですか？`,
        ].join('<br>'),
        type: 'is-danger',
        cancelText: 'やめる',
        confirmText: '終了する',
        onCancel: () => {},
        onConfirm: () => {
          axios.post('/api/app/surveys/' + survey.id + '/finish').then(({ data }) => {
            this.$toast.open({
              message: `「${survey.title}」を終了しました。`,
              type: 'is-success'
            })

            this.refresh().then(() => {
              this.setHighlightRow(data.data.id)
            })
          })
        },
      })
    },

    setHighlightRow(id) {
      this.highlightRow = id;
      setTimeout(() => this.highlightRow = null, 5000)
    }
  }
}
</script>

<style>
.hightlightRowBase {
  background-color: #fff;
  transition: background-color 1s ease;
}
.highlightRow {
  background-color: #fffbee;
  transition: background-color 1s ease;
}
</style>
